// English translations - moved outside i18n folder to avoid babel-plugin-formatjs processing
const enMessages = {
  // Login page
  "login.page.title": "Login | {siteName}",
  "login.user.identity.label": "Username or email",
  "login.password.label": "Password",
  "sign.in.button": "Sign in",
  "forgot.password": "Forgot password",
  "institution.login.button": "Institution/campus credentials",
  "institution.login.page.title": "Sign in with institution/campus credentials",
  "institution.login.page.sub.heading": "Choose your institution from the list below",
  "non.compliant.password.title": "We recently changed our password requirements",
  "non.compliant.password.message": "Your current password does not meet the new security requirements. We just sent a password-reset message to the email address associated with this account. Thank you for helping us keep your data safe.",
  "account.locked.out.message.1": "To protect your account, it's been temporarily locked. Try again in 30 minutes.",
  "username.or.email.format.validation.less.chars.message": "Username or email must have at least 2 characters.",
  "email.validation.message": "Enter your username or email",
  "password.validation.message": "Enter your password",
  "account.activation.success.message.title": "Success! You have activated your account.",
  "account.activation.success.message": "You will now receive email updates and alerts from us related to the courses you are enrolled in. Sign in to continue.",
  "account.activation.info.message": "This account has already been activated.",
  "account.activation.error.message.title": "Your account could not be activated",
  "account.activation.support.link": "contact support",
  "account.confirmation.success.message.title": "Success! You have confirmed your email.",
  "account.confirmation.success.message": "Sign in to continue.",
  "account.confirmation.info.message": "This email has already been confirmed.",
  "account.confirmation.error.message.title": "Your email could not be confirmed",
  "tpa.account.link": "{provider} account",
  "internal.server.error.message": "An error has occurred. Try refreshing the page, or check your internet connection.",
  "login.rate.limit.reached.message": "Too many failed login attempts. Try again later.",
  "login.failure.header.title": "We couldn't sign you in.",
  "contact.support.link": "contact {platformName} support",
  "login.incorrect.credentials.error": "The username, email, or password you entered is incorrect. Please try again.",
  "login.form.invalid.error.message": "Please fill in the fields below.",
  "login.incorrect.credentials.error.reset.link.text": "reset your password",
  "login.incorrect.credentials.error.before.account.blocked.text": "click here to reset it.",
  "password.security.nudge.title": "Password security",
  "password.security.block.title": "Password change required",
  "password.security.nudge.body": "Our system detected that your password is vulnerable. We recommend you change it so that your account stays secure.",
  "password.security.block.body": "Our system detected that your password is vulnerable. Change your password so that your account stays secure.",
  "password.security.close.button": "Close",
  "password.security.redirect.to.reset.password.button": "Reset your password",
  "login.tpa.authentication.failure": "We are sorry, you are not authorized to access {platform_name} via this channel. Please contact your learning administrator or manager in order to access {platform_name}.{lineBreak}{lineBreak}Error Details:{lineBreak}{errorMessage}",
  "logistration.sign.in": "Sign in",
  "logistration.register.link.prefix": "Don't have an account?",
  "logistration.register.link.text": "Register now",
  "login.email.help.text": "The email you used to register on {platformName}",
  "logistration.remember.me": "Remember me",
  "forgot.password.prefix": "Forgot your password?",
  "forgot.password.link.text": "Click here",
  "logistration.social.login.title": "Or sign in using",

  // Register page
  "register.page.title": "Register | {siteName}",
  "registration.fullname.label": "Name in English",
  "registration.fullname.ar.label": "Name in Arabic",
  "help.text.name.ar": "Enter your full name in Arabic.",
  "registration.email.label": "Email",
  "registration.username.label": "Public username",
  "registration.password.label": "Password",
  "registration.country.label": "Country/Region",
  "registration.opt.in.label": "I agree that {siteName} may send me marketing messages.",
  "help.text.name": "This name will be used by any certificates that you earn.",
  "help.text.username.1": "The name that will identify you in your courses.",
  "help.text.username.2": "This can not be changed later.",
  "help.text.email": "For account activation and important updates",
  "create.account.for.free.button": "Create an account for free",
  "create.account.cta.button": "{label}",
  "register.institution.login.page.title": "Register with institution/campus credentials",
  "empty.name.field.error": "Enter your full name",
  "empty.email.field.error": "Enter your email",
  "empty.username.field.error": "Username must be between 2 and 30 characters",
  "empty.password.field.error": "Password criteria has not been met",
  "empty.country.field.error": "Select your country or region of residence",
  "invalid.country.field.error": "Country must match with an option available in the dropdown.",
  "email.do.not.match": "The email addresses do not match.",
  "email.invalid.format.error": "Enter a valid email address",
  "username.validation.message": "Username must be between 2 and 30 characters",
  "name.validation.message": "Enter a valid name",
  "name.en.validation.message": "Name must contain English letters only",
  "name.ar.validation.message": "Name must contain Arabic letters only",
  "username.format.validation.message": "Usernames can only contain letters (A-Z, a-z), numerals (0-9), underscores (_), and hyphens (-). Usernames cannot contain spaces",
  "registration.request.failure.header": "We couldn't create your account.",
  "registration.empty.form.submission.error": "Please check your responses and try again.",
  "registration.request.server.error": "An error has occurred. Try refreshing the page, or check your internet connection.",
  "registration.rate.limit.error": "Too many failed registration attempts. Try again later.",
  "registration.tpa.session.expired": "Registration using {provider} has timed out.",
  "registration.forbidden.username": "Usernames can't include words that could be mistaken for course roles. Please choose a different username.",
  "registration.tpa.authentication.failure": "We are sorry, you are not authorized to access {platform_name} via this channel. Please contact your learning administrator or manager in order to access {platform_name}.{lineBreak}{lineBreak}Error Details:{lineBreak}{errorMessage}",
  "terms.of.service.and.honor.code": "Terms of Service and Honor Code",
  "privacy.policy": "Privacy Policy",
  "honor.code": "Honor Code",
  "terms.of.service": "Terms of Service",
  "registration.username.suggestion.label": "Suggested:",
  "did.you.mean.alert.text": "Did you mean",

  // Reset password
  "reset.password.page.title": "Reset Password | {siteName}",
  "reset.password": "Reset password",
  "reset.password.page.instructions": "Enter and confirm your new password.",
  "new.password.label": "New password",
  "confirm.password.label": "Confirm password",
  "passwords.do.not.match": "Passwords do not match",
  "confirm.your.password": "Confirm your password",
  "reset.password.failure.heading": "We couldn't reset your password.",
  "reset.password.form.submission.error": "Please check your responses and try again.",
  "reset.server.rate.limit.error": "Too many requests.",
  "reset.password.success.heading": "Password reset complete.",
  "reset.password.success": "Your password has been reset. Sign in to your account.",
  "internal.server.error": "An error has occurred. Try refreshing the page, or check your internet connection.",
  "rate.limit.error": "An error has occurred because of too many requests. Please try again after some time.",
  "sign.in": "Sign in",

  // Common components
  "show.password": "Show password",
  "hide.password": "Hide password",
  "one.letter": "1 letter",
  "one.number": "1 number",
  "eight.characters": "8 characters",
  "password.sr.only.helping.text": "Password must contain at least 8 characters, at least one letter, and at least one number",
  "tpa.alert.heading": "Almost done!",
  "login.third.party.auth.account.not.linked": "You have successfully signed into {currentProvider}, but your {currentProvider} account does not have a linked {platformName} account. To link your accounts, sign in now using your {platformName} password.",
  "register.third.party.auth.account.not.linked": "You've successfully signed into {currentProvider}! We just need a little more information before you start learning with {platformName}.",
  "registration.using.tpa.form.heading": "Finish creating your account",
  "supportTitle": "edX Support",
  "selectTicketForm": "Please choose your request type:",
  "registration.other.options.heading": "Or register with:",
  "login.other.options.heading": "Or sign in with:",
  "enterprise.login.btn.text": "Company or school credentials",
  "logistration.register": "Register",
  "enterprisetpa.title.heading": "Would you like to sign in using your {providerName} credentials?",
  "enterprisetpa.login.button.text": "Show me other ways to sign in or register",
  "enterprisetpa.login.button.text.public.account.creation.disabled": "Show me other ways to sign in",
  "sso.sign.in.with": "Sign in with {providerName}",
  "sso.create.account.using": "Create account using {providerName}",

  // Forgot password
  "forgot.password.page.title": "Forgot Password | {siteName}",
  "forgot.password.page.heading": "Reset password",
  "forgot.password.page.instructions": "Please enter your email address below and we will send you an email with instructions on how to reset your password.",
  "forgot.password.page.invalid.email.message": "Enter a valid email address",
  "forgot.password.page.email.field.label": "Email",
  "forgot.password.page.submit.button": "Submit",
  "forgot.password.error.alert.title": "We were unable to contact you.",
  "forgot.password.error.message.title": "An error occurred.",
  "forgot.password.request.in.progress.message": "Your previous request is in progress, please try again in a few moments.",
  "forgot.password.empty.email.field.error": "Enter your email",
  "forgot.password.email.help.text": "The email address you used to register with {platformName}",
  "confirmation.message.title": "Check your email",
  "confirmation.support.link": "contact technical support",
  "need.help.sign.in.text": "Need help signing in?",
  "additional.help.text": "For additional help, contact {platformName} support at ",
  "sign.in.text": "Sign in",
  "extend.field.errors": "{emailError} below.",
  "invalid.token.heading": "Invalid password reset link",
  "invalid.token.error.message": "This password reset link is invalid. It may have been used already. Enter your email below to receive a new link.",
  "token.validation.rate.limit.error.heading": "Too many requests",
  "token.validation.rate.limit.error": "An error has occurred because of too many requests. Please try again after some time.",
  "token.validation.internal.sever.error.heading": "Token validation failure",
  "token.validation.internal.sever.error": "An error has occurred. Try refreshing the page, or check your internet connection.",

  // Progressive profiling
  "progressive.profiling.page.title": "Welcome | {siteName}",
  "progressive.profiling.page.heading": "A few questions for you will help us get smarter.",
  "optional.fields.information.link": "Learn more about how we use this information.",
  "optional.fields.submit.button": "Submit",
  "optional.fields.skip.button": "Skip for now",
  "optional.fields.next.button": "Next",
  "continue.to.platform": "Continue to {platformName}",
  "modal.title": "Thanks for letting us know.",
  "modal.description": "You can complete your profile in settings at any time if you change your mind.",
  "welcome.page.error.heading": "We couldn't update your profile",
  "welcome.page.error.message": "An error occurred. You can complete your profile in settings at any time.",

  // Recommendations
  "recommendation.page.title": "Recommendations | {siteName}",
  "recommendation.page.heading": "We have a few recommendations to get you started.",
  "recommendation.skip.button": "Skip for now",
  "recommendation.option.trending": "Trending Now",
  "recommendation.option.popular": "Most Popular",
  "recommendation.option.recommended.for.you": "Recommended For You",
  "recommendation.product-card.pill-text.course": "Course",
  "recommendation.product-card.pill-text.professional-certificate": "Professional Certificate",
  "recommendation.product-card.pill-text.emeritus": "Offered on Emeritus",
  "recommendation.product-card.pill-text.shorelight": "Offered through Shorelight",
  "recommendation.product-card.footer-text.number-of-courses": "{length} {label}",
  "recommendation.product-card.footer-text.subscription": "Subscription",
  "recommendation.product-card.launch-icon.sr-text": "Opens a link in a new tab",

  // FormattedMessage replacements
  "login.inactive.user.error": "In order to sign in, you need to activate your account.{lineBreak}{lineBreak}We just sent an activation link to {email}. If you do not receive an email, check your spam folders or {supportLink}.",
  "allowed.domain.login.error": "As {allowedDomain} user, You must login with your {allowedDomain} {tpaLink}.",
  "login.incorrect.credentials.error.attempts.text.1": "The username, email or password you entered is incorrect. You have {remainingAttempts} more sign in attempts before your account is temporarily locked.",
  "login.incorrect.credentials.error.attempts.text.2": "If you've forgotten your password, {resetLink}",
  "account.locked.out.message.2": "To be on the safe side, you can {resetLink} before trying again.",
  "login.incorrect.credentials.error.with.reset.link": "The username, email, or password you entered is incorrect. Please try again or {resetLink}.",
  "account.activation.error.message": "Something went wrong, please {supportLink} to resolve this issue.",
  "forgot.password.confirmation.message": "We sent an email to {email} with instructions to reset your password. If you do not receive a password reset message after 1 minute, verify that you entered the correct email address, or check your spam folder. If you need further assistance, {supportLink}.",
  "error.notfound.message": "The page you're looking for is unavailable or there's an error in the URL. Please check the URL and try again.",
  "register.page.terms.of.service.and.honor.code": "By creating an account, you agree to the {tosAndHonorCode} and you acknowledge that {platformName} and each Member process your personal data in accordance with the {privacyPolicy}.",
  "register.page.honor.code": "I agree to the {platformName}\u00a0{tosAndHonorCode}",
  "register.page.terms.of.service": "I agree to the {platformName}\u00a0{termsOfService}",

  // Base container layouts
  "start.learning": "Start learning",
  "with.site.name": "with {siteName}",
  "your.career.turning.point": "Your career turning point",
  "is.here": "is here.",
  "welcome.to.platform": "Welcome to {siteName}, {fullName}!",
  "complete.your.profile.1": "Complete",
  "complete.your.profile.2": "your profile",
};

module.exports = enMessages;
